import React from 'react'
import useIconSize from '../icon-size'
import IconPropTypes from '../IconPropTypes'

function IconAtSign({ size, ...props }) {
  const sizeValue = useIconSize(size)
  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 8.412a3.592 3.592 0 00-3.588 3.587A3.592 3.592 0 0012 15.587 3.592 3.592 0 0015.588 12 3.592 3.592 0 0012 8.412zm0 5.883a2.298 2.298 0 01-2.295-2.296A2.298 2.298 0 0112 9.704 2.298 2.298 0 0114.295 12 2.298 2.298 0 0112 14.295z"
      />
      <path
        fill="currentColor"
        d="M17.657 6.343A7.947 7.947 0 0012 4a7.947 7.947 0 00-5.657 2.343A7.947 7.947 0 004 12.002c0 2.136.832 4.145 2.343 5.656A7.948 7.948 0 0012 20a8.044 8.044 0 004.864-1.648.646.646 0 10-.786-1.027A6.744 6.744 0 0112 18.707a6.664 6.664 0 01-4.743-1.964A6.664 6.664 0 015.293 12 6.715 6.715 0 0112 5.293 6.715 6.715 0 0118.707 12v.735c0 .86-.7 1.56-1.56 1.56-.86 0-1.56-.7-1.56-1.56V12a.646.646 0 10-1.292 0v.735a2.856 2.856 0 002.853 2.852A2.856 2.856 0 0020 12.735v-.736a7.948 7.948 0 00-2.343-5.656z"
      />
    </svg>
  )
}

IconAtSign.propTypes = IconPropTypes
export default IconAtSign
